const E = {
  BOOL: "BOOL",
  URL: "URL",
  REPEATABLE_URL: "REPEATABLE_URL",
  ENUM: "ENUM",
  REPEATABLE_ENUM: "REPEATABLE_ENUM"
};
export {
  E as attributesEnumType
};
